export enum CardOrienationOption {
  PORTRAIT = 'portrait',
  LANDSCAPE = 'landspace'
}
